import { Print } from "@mui/icons-material";
import { Box, Container, Typography } from "@mui/material";
import { useRef } from "react";
import { useReactToPrint } from 'react-to-print';
import Logo from "../../assets/images/nepalbanklimited.png";
import moment from "moment";

export default function LockerReleaseFormTemplate({ selectedItem }: { selectedItem: any }) {
    const componentRef = useRef(null)

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (
        <>
            <button style={{ fontSize: '12px', padding: '8px', marginLeft: '30px', borderRadius: '2px', background: '#3150A1', color: 'white', border: 'none', cursor: 'pointer' }} onClick={() => handlePrint()}>
                <Print style={{ fontSize: '12px' }} /> Print Document
            </button>
            <div ref={componentRef} style={{ position: 'relative' }}>
                <Box sx={{}}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '5px', marginTop: '5px' }}>
                        <img src={Logo} alt="logo" style={{ width: '150px', height: '50px' }} />
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                            <Typography style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'center', paddingTop: '5px' }}>त्याग</Typography>
                        </div>
                    </div>
                    <Container sx={{ width: "100%", marginTop: '10px' }}>
                        <Typography style={{ fontSize: '12px', lineHeight: '2', textAlign: 'justify' }}>
                            नेपाल बैंक लि. काठमाडौं भल्टमा रहेको लकर नं. <span style={{ fontSize: '12px', fontWeight: 'bold', borderBottom: '1px dashed black', }}>{selectedItem?.lockerNumber}</span> को मालहरू हटाइएको हुँदा उक्त लकर र साँचो यसैसाथ
                            बुझाएका छु / छौं । उक्त बैंकको यस लकरको भाडाको दायित्व मैले / हामीले यसैद्वारा छोडि दिएको छु/छौं ।
                        </Typography>
                    </Container>
                </Box >
                <div style={{ padding: '0px 30px', marginTop: '100px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '30px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <Typography style={{ fontSize: '12px', width: '180px', textAlign: 'center', borderTop: '1px dashed black', paddingTop: '5px' }}>दस्तखत भल्ट रक्षक आफसर</Typography>
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
                            <Typography style={{ fontSize: '12px', textAlign: 'center', paddingTop: '5px' }}>मिति</Typography>
                            <Typography style={{ fontSize: '12px', textAlign: 'center', borderBottom: '1px dashed black', paddingTop: '5px' }}>{moment().format('YYYY-MM-DD')}</Typography>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <Typography style={{ fontSize: '10px', fontWeight: 'bold', width: '180px', textAlign: 'center', paddingTop: '5px' }}>
                            लकर हेरी खाली पाएको.
                        </Typography>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <Typography style={{ fontSize: '12px', width: '180px', textAlign: 'center', borderTop: '1px dashed black', paddingTop: '5px' }}>दस्तखत</Typography>
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
                            <Typography style={{ fontSize: '12px', textAlign: 'center', paddingTop: '5px' }}>मिति</Typography>
                            <Typography style={{ fontSize: '12px', textAlign: 'center', borderBottom: '1px dashed black', paddingTop: '5px' }}>{moment().format('YYYY-MM-DD')}</Typography>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
}
